export default __webpack_public_path__ + "static/media/EA-Logo.2d9f4a34.png";